import React from 'react'
import { Col, Input, Row, Typography } from 'antd'

export interface CgvDataJson {
  raison_sociale?: string
  forme_juridique?: string
  capital_social?: string
  postal_code?: string
  city?: string
  address?: string
  name_rcs?: string
  siren?: string
  siret?: string
  signataire?: string
  fonction_signataire?: string
  email_signataire?: string
}

export const CGV_FORM_FIELDS: { key: keyof CgvDataJson; label: string; fullWidth?: boolean }[] = [
  { key: 'raison_sociale', label: 'Raison sociale', fullWidth: true },
  { key: 'forme_juridique', label: 'Forme juridique' },
  { key: 'capital_social', label: 'Capital social' },
  { key: 'address', label: 'Adresse siège social', fullWidth: true },
  { key: 'postal_code', label: 'CP siège social' },
  { key: 'city', label: 'Ville siège social' },
  { key: 'name_rcs', label: 'Nom RCS' },
  { key: 'siret', label: 'Siret' },
  { key: 'signataire', label: 'Signataire' },
  { key: 'fonction_signataire', label: 'Fonction signataire' },
  { key: 'email_signataire', label: 'Email signataire', fullWidth: true },
]

export function parseCgvDataJson(raw?: string | CgvDataJson | null): CgvDataJson {
  if (raw == null || raw === '') return {}
  if (typeof raw === 'object' && !Array.isArray(raw)) return raw
  if (typeof raw !== 'string') return {}
  try {
    const parsed = JSON.parse(raw)
    if (parsed == null || typeof parsed !== 'object' || Array.isArray(parsed)) return {}
    return parsed
  } catch {
    return {}
  }
}

/** Formulaire champs CGV partagé (page Facturation + page Organisation). */
export function CgvDataJsonForm(props: {
  value: CgvDataJson
  onChange: (next: CgvDataJson) => void
  /** false = stack verticale (Popover Facturation), true = grille (Modal Org) */
  layout?: 'stack' | 'grid'
}) {
  const layout = props.layout || 'stack'
  const value = props.value ?? {}
  const fields = CGV_FORM_FIELDS.map(({ key, label, fullWidth }) => {
    const input = (
      <>
        <Typography.Text style={{ fontSize: 12 }}>{label}</Typography.Text>
        <Input
          value={value[key] || ''}
          onChange={e => props.onChange({ ...value, [key]: e.target.value })}
        />
      </>
    )
    if (layout === 'stack') {
      return (
        <React.Fragment key={key}>
          {input}
          <br />
        </React.Fragment>
      )
    }
    return (
      <Col key={key} xs={24} sm={fullWidth ? 24 : 12}>
        {input}
      </Col>
    )
  })

  if (layout === 'grid') {
    return <Row gutter={[12, 12]}>{fields}</Row>
  }
  return <>{fields}</>
}
